//import StuListViewArea from "@/pages/comp/basic/student/common/list_view";
import strFunc from "@/lib/lyg/string";
import WritePage from "@/pages/comp/basic/student/common/write";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import { useRef, useState, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";

function StuListViewArea(props: any) {
  let myProps = {
    select_mcomp_data: {
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    write_page_data: {},
    callback_refresh_data: (inData: any) => { },
    closePopup: () => { },
    ...props
  };
  let select_mcomp_data = myProps.select_mcomp_data;
  let default_write_page_data = {
    is_show: false,
    is_update: false,
    is_view_mode: true,
    set_is_view_mode: (inData: any) => { },
    is_view_basic: true,
    info_arr: [],
    select_idx: 0,
    default_write_info: {},
    tab_id: "discover_map",
    is_first_tab_scroll: false,
    counsel_s_select_date: "",
    month_prescribe_s_subject: "",
  };
  let write_page_data = {
    ...default_write_page_data,
    ...myProps.write_page_data
  };

  const [info_arr, set_info_arr] = useState(write_page_data.info_arr);
  const [is_view_mode, set_is_view_mode] = useState(write_page_data.is_view_mode);
  const left_box_ref = useRef<any>(null);
  const WritePageRef = useRef<any>(null);

  const get_stu_info_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq_arr: [],
      ...inData
    };
    let stu_seq_arr = opt_obj.stu_seq_arr;

    if (stu_seq_arr.length == 0) {
      return false;
    }
    let tmp_list_opt: any = {
      "s_seq": stu_seq_arr,
      "s_addon_add_memo": "1",
      s_addon_lecture_time: "1",
      "is_paging": "",
    };
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      tmp_list_opt["api_key"] = select_mcomp_data.api_key;
      tmp_list_opt["api_user_seq"] = select_mcomp_data.api_user_seq;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let tmp_user_info_arr = [];
          for (let i = 0; i < stu_seq_arr.length; i++) {
            for (let j = 0; j < response.data["data"]["info_arr"].length; j++) {
              if (stu_seq_arr[i] == response.data["data"]["info_arr"][j]["a_seq"]) {
                tmp_user_info_arr.push(response.data["data"]["info_arr"][j]);
              }
            }
          }
          set_info_arr(tmp_user_info_arr);
          if (WritePageRef.current && tmp_user_info_arr.length > 0) {
            WritePageRef.current.setInitData({
              "info_arr": tmp_user_info_arr,
              "select_idx": 0,
              "is_view_mode": is_view_mode,
              counsel_s_select_date: write_page_data.counsel_s_select_date
            });
          }
        } else {

        }
      });
  };

  const closePopup = () => {
    if (WritePageRef.current) {
      let is_exist_modify = WritePageRef.current.get_is_exist_modify();
      if (is_exist_modify) {
        if (!window.confirm("작성중인 내용이 있습니다. 뒤로가시겠습니까??")) {
          return;
        }
      }
    }
    myProps.closePopup();
  };

  let select_stu_grade_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });
  let stu_name = "";
  let stu_school_name = "";
  let stu_grade_str = "";
  let select_stu_info: any = {};
  let stu_join_date = "";
  let stu_t_sort = "";
  let lecture_name_str = "";
  if (write_page_data.is_update == false) {
    stu_name = "학생 신규등록";
  }
  if (info_arr && info_arr[write_page_data.select_idx]) {
    select_stu_info = info_arr[write_page_data.select_idx];
    stu_name = select_stu_info["a_user_name"];
    stu_school_name = select_stu_info["a_school_name"];
    stu_grade_str = select_stu_info["a_stu_grade"];
    stu_join_date = select_stu_info["a_join_date"];
    if (strFunc.is_empty(stu_join_date)) {
      stu_join_date = "";
    }
    if (select_stu_info.add_memo_info) {
      stu_t_sort = select_stu_info.add_memo_info.a_stu_total_code;
    }
    if (select_stu_grade_option_arr) {
      for (let i = 0; i < select_stu_grade_option_arr.length; i++) {
        let row_option = select_stu_grade_option_arr[i];
        if (row_option["value"] == stu_grade_str) {
          stu_grade_str = row_option["text"];
        }
      }
    }
    if (select_stu_info.lecture_arr && select_stu_info.lecture_arr.length > 0) {
      for (let i = 0; i < select_stu_info.lecture_arr.length; i++) {
        if (i > 0) {
          lecture_name_str += "/ ";
        }
        lecture_name_str += strFunc.cut_str(select_stu_info.lecture_arr[i].a_name, 4, "..");
      }
    }
  }

  return (
    <div style={{ display: "flex", width: "100%", gap: "10px" }}>
      {write_page_data.is_update &&
        <div style={{ minWidth: "240px" }} >
          <div ref={left_box_ref}>
            <FindStudentList
              show_key_arr={[]}
              info_arr={info_arr}
              is_first_search={false}
              first_select_seq_arr={[write_page_data.default_write_info["a_seq"]]}
              grid_opt={{
                rowSelection: "single",
                height: window.innerHeight - 270,
                domLayout: "normal",
              }}
              is_use_paging={false}
              list={(inData: any) => {
                if (inData.s_stu_user_seq && inData.s_stu_user_seq.length > 0) {
                  get_stu_info_arr_by_ajax({ stu_seq_arr: inData.s_stu_user_seq });
                }
              }}
              show_search_key_arr={["s_stu_lecture_seq","s_search_text", "s_stu_grade"]}
            ></FindStudentList>
          </div>
        </div>
      }
      <div style={{ flexGrow: 1 }}>
        <WritePage
          ref={WritePageRef}
          select_mcomp_data={{ ...select_mcomp_data }}
          info_arr={write_page_data.info_arr}
          select_idx={write_page_data.select_idx}
          close_write={() => { closePopup(); }}
          close_btn_name={"뒤로가기"}
          is_view_close_btn={false}
          is_view_write_btn={true}
          list={() => { myProps.callback_refresh_data(); }}
          refresh_data={() => {
            myProps.callback_refresh_data();
          }}
          is_update={write_page_data.is_update}
          is_view_mode={write_page_data.is_view_mode}
          set_is_view_mode={set_is_view_mode}
          is_view_basic={write_page_data.is_view_basic}
          default_write_info={write_page_data.default_write_info}
          tab_id={write_page_data.tab_id}
          is_first_tab_scroll={write_page_data.is_first_tab_scroll}
          counsel_s_select_date={write_page_data.counsel_s_select_date}
          month_prescribe_s_subject={write_page_data.month_prescribe_s_subject}
        ></WritePage>
      </div>
      <RightScrollFix
        right_ref={left_box_ref}
        limit_scroll_top={150}
      ></RightScrollFix>
    </div>
  );
};
export default StuListViewArea;